// Ordine personale delle voci del menu a sinistra (solo il primo livello).

// Chiave stabile di una voce: le sezioni con sottomenu hanno "state", le altre il percorso.
export const itemKey = (route) => route.state || route.path || route.name;

const isShown = (route) => route.showSidebar !== false && !route.redirect;

// Le voci nell'ordine scelto dal cliente; quelle nuove (non ancora ordinate) restano in fondo
// nell'ordine originale.
export const applyOrder = (routes, order) => {
  const saved = Array.isArray(order) ? order : [];
  if (saved.length === 0) return routes;
  const rank = (route) => {
    const i = saved.indexOf(itemKey(route));
    return i === -1 ? saved.length : i;
  };
  return routes
    .map((route, index) => ({ route, index }))
    .sort((a, b) => rank(a.route) - rank(b.route) || a.index - b.index)
    .map((x) => x.route);
};

// Chiavi delle voci visibili, nell'ordine in cui compaiono.
export const visibleKeys = (routes) => routes.filter(isShown).map(itemKey);

// Sposta la chiave "key" davanti a "beforeKey" (null = in fondo).
export const moveKey = (keys, key, beforeKey) => {
  if (key === beforeKey || !keys.includes(key)) return keys;
  const rest = keys.filter((k) => k !== key);
  const at = beforeKey == null ? rest.length : rest.indexOf(beforeKey);
  if (at === -1) return keys;
  return [...rest.slice(0, at), key, ...rest.slice(at)];
};

// Da salvare: le voci visibili nel nuovo ordine, poi quelle salvate in passato ma ora non visibili
// (per esempio un modulo disattivato), cosi' non perdono il loro posto.
export const mergeOrder = (visible, saved) => [
  ...visible,
  ...(Array.isArray(saved) ? saved : []).filter((k) => !visible.includes(k)),
];
